export default {"src":"/_next/static/media/chat2.751c8c2a.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};